import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledLiveMatch,
  StyledOnlineIcon,
  StyledWatchDiscord,
  StyledLiveBadge,
  StyledLiveDot,
} from './styled';
import { goToDiscordLogin } from '../../service/functions';

const LiveMatch = ({
  discordChannelId,
  title = '',
  theme,
  isAuthenticated,
  variant,
  compact,
}) => {
  const goToDiscordChannel = () => {
    if (isAuthenticated) {
      window.open(`https://discord.com/channels/${discordChannelId}`, '_blank');
    } else {
      goToDiscordLogin();
    }
  };

  if (variant === 'watch') {
    return (
      <StyledWatchDiscord type="button" onClick={goToDiscordChannel}>
        <StyledLiveBadge>
          <StyledLiveDot />
          LIVE
        </StyledLiveBadge>
        Watch on Discord
      </StyledWatchDiscord>
    );
  }

  return (
    <StyledLiveMatch
      $chrome={theme}
      $compact={compact}
      onClick={() => goToDiscordChannel(discordChannelId)}
    >
      <StyledOnlineIcon $compact={compact} /> {title}
    </StyledLiveMatch>
  );
};

LiveMatch.propTypes = {
  discordChannelId: PropTypes.string,
  title: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']),
  variant: PropTypes.oneOf(['default', 'watch']),
  compact: PropTypes.bool,
};
LiveMatch.defaultProps = {
  discordChannelId: '',
  title: '',
  theme: 'light',
  isAuthenticated: false,
  variant: 'default',
  compact: false,
};
export default LiveMatch;
